export const EMAIL_REGEXP = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;
export const validateLoginForm = (values) => {
   let errors = {};
   if (values) {
      if (!values.email) {
         errors.email = 'This field is required.';
      } else if (!EMAIL_REGEXP.test(values.email)) {
         errors.email = 'Please add a valid email.';
      }

      if (!values.password) {
         errors.password = 'This field is required.';
      }
   } else {
      errors.email = 'This field is required.';
      errors.password = 'This field is required.';
   }
   return errors;
};

export const validateSignupForm = (values) => {
   let errors = {};
   if (values) {
      if (!values.first_name) {
         errors.first_name = 'This field is required.';
      }

      if (!values.last_name) {
         errors.last_name = 'This field is required.';
      }

      if (!values.email) {
         errors.email = 'This field is required.';
      }

      if (!values.password) {
         errors.password = 'This field is required.';
      }

      if (!values.confirmpass) {
         errors.confirmpass = 'This field is required.';
      } else if (values.password !== values.confirmpass) {
         errors.confirmpass = 'Password do not match';
      }
   } else {
      errors.email = 'This field is required.';
      errors.password = 'This field is required.';
      errors.confirmpass = 'This field is required.';
      errors.first_name = 'This field is required.';
      errors.last_name = 'This field is required.';
   }
   return errors;
};

export const validateForgotForm = (values) => {
   let errors = {};
   if (values) {
      if (!values.email) {
         errors.email = 'This field is required.';
      }
   } else {
      errors.email = 'This field is required.';
   }
   return errors;
};

export const validateResetForm = (values) => {
   let errors = {};
   if (values) {
      if (!values.password) {
         errors.password = 'This field is required.';
      }
      if (!values.password_confirmation) {
         errors.password_confirmation = 'This field is required.';
      }
      // if (values.password !== values.password_confirmation) {
      //    errors.notsame = 'Passwords not same';
      // }
      if (values.password !== values.password_confirmation) {
         errors.password_confirmation = 'Password do not match';
      }
   } else {
      errors.password = 'This field is required.';
      errors.password_confirmation = 'This field is required.';
      // errors.notsame = 'Passwords not same';
   }
   return errors;
};

export const validateVerificationForm = (values) => {
   let errors = {};
   if (values) {
      if (!values.code) {
         errors.code = 'This field is required.';
      }
   } else {
      errors.code = 'This field is required.';
   }
   return errors;
};

export const validateProfileForm = (values) => {
   let errors = {};
   if (values) {
      if (!values.first_name) {
         errors.first_name = 'This field is required.';
      }

      if (!values.last_name) {
         errors.last_name = 'This field is required.';
      }
   } else {
      errors.first_name = 'This field is required.';
      errors.last_name = 'This field is required.';
   }
   return errors;
};
